function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.9 31h19v24h-19zM5.9 22h13v33h-13zM37.9 22h13v33h-13zM23.9 20h9v11h-9zM24.9 12.615L28.26 8l3.64 4.615V20h-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4 36s-4 1.79-4 4v12h8V40c0-2.21-4-4-4-4zM12.4 41.333A2.667 2.667 0 009.733 44v8h5.334v-8a2.667 2.667 0 00-2.667-2.667zM44.4 41.333A2.667 2.667 0 0041.733 44v8h5.334v-8a2.667 2.667 0 00-2.667-2.667zM28.4 14s-1.5.672-1.5 1.5V20h3v-4.5c0-.828-1.5-1.5-1.5-1.5zM28.3 8V1M28.1 2c5.8-3 5.8 1 13.8 3-4 2-9-2-13.8 0M3.9 19h17v3h-17zM4.9 16h3v3h-3zM10.9 16h3v3h-3zM16.9 16h3v3h-3zM35.9 19h17v3h-17zM36.9 16h3v3h-3zM42.9 16h3v3h-3zM48.9 16h3v3h-3z"
}));

var SvgCastle = function SvgCastle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCastle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Castle.8d998321.svg";
export { ForwardRef as ReactComponent };